export enum LandingActionKey {
  BasicInfo = 'jbp-basicinfo',
  FinSob = 'jbp-finsobplan',
  KeyInitiatives = 'jbp-initiatives-total',
  Acknowledgement = 'jbp-acknowledgment',
  ManagerRemind = 'jbp-manager-reminder',
  PartnerRemind = 'jbp-partner-reminder',
  InitPlan = 'jbp-initplan',
  ManagerReviewReminder = 'jbp-manager-review-reminder',
  PBMReviewReminder = 'jbp-pbm-review-reminder',
}
